import React from 'react';
import { Mail, Phone, MapPin, Globe, Printer } from 'lucide-react';
export function ContactInfoSection() {
  return <div className="lg:col-span-2 space-y-6" data-id="element-342">
      <h2 className="text-2xl font-bold text-brand-white uppercase tracking-wide mb-8" data-id="element-343">
        New Jersey Office Contact
      </h2>

      <div className="p-6 border border-brand-gray-800 bg-brand-gray-900" data-id="element-344">
        <div className="flex items-start gap-4" data-id="element-345">
          <MapPin className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-346" />
          <div data-id="element-347">
            <h3 className="text-sm font-bold text-brand-white uppercase tracking-wider mb-1" data-id="element-348">
              Address
            </h3>
            <p className="text-brand-gray-400" data-id="element-349">
              P.O. Box 6936, Piscataway, NJ 08855
            </p>
          </div>
        </div>
      </div>

      <div className="p-6 border border-brand-gray-800 bg-brand-gray-900" data-id="element-350">
        <div className="flex items-start gap-4" data-id="element-351">
          <Phone className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-352" />
          <div data-id="element-353">
            <h3 className="text-sm font-bold text-brand-white uppercase tracking-wider mb-2" data-id="element-354">
              Phone
            </h3>
            <p className="text-brand-gray-400 text-sm mb-1" data-id="element-355">
              USA New Jersey Office:
            </p>
            <a href="tel:18666343373" className="text-brand-teal hover:text-brand-teal-light transition-colors font-bold block mb-3" data-id="element-356">
              1-866-634-3373
            </a>
          </div>
        </div>
      </div>

      <div className="p-6 border border-brand-gray-800 bg-brand-gray-900" data-id="element-357">
        <div className="flex items-start gap-4" data-id="element-358">
          <Printer className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-359" />
          <div data-id="element-360">
            <h3 className="text-sm font-bold text-brand-white uppercase tracking-wider mb-2" data-id="element-361">
              Fax
            </h3>
            <p className="text-brand-gray-400 text-sm mb-1" data-id="element-362">
              USA New Jersey Fax:
            </p>
            <p className="text-brand-white font-bold mb-3" data-id="element-363">1-866-635-5761</p>
            <p className="text-brand-gray-400 text-sm mb-1" data-id="element-364">
              International Fax:
            </p>
            <p className="text-brand-white font-bold" data-id="element-365">1-866-635-5761</p>
          </div>
        </div>
      </div>

      <div className="p-6 border border-brand-gray-800 bg-brand-gray-900" data-id="element-366">
        <div className="flex items-start gap-4" data-id="element-367">
          <Mail className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-368" />
          <div data-id="element-369">
            <h3 className="text-sm font-bold text-brand-white uppercase tracking-wider mb-1" data-id="element-370">
              Email
            </h3>
            <a href="mailto:Info@apc360zone.com" className="text-brand-teal hover:text-brand-teal-light transition-colors font-bold" data-id="element-371">
              Info@apc360zone.com
            </a>
          </div>
        </div>
      </div>

      <div className="p-6 border-l-4 border-brand-teal bg-brand-gray-900/50" data-id="element-372">
        <div className="flex items-start gap-4" data-id="element-373">
          <Globe className="w-5 h-5 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-374" />
          <p className="text-brand-gray-300 leading-relaxed" data-id="element-375">
            We are a global Consulting and Training Firm capable of traveling to
            your location.
          </p>
        </div>
      </div>
    </div>;
}